// 公共常量
// this.$finalData.xx 调用

export default {
  B2BChannelId: 1,
  LoadingBgColorAll: 'rgba(255, 255, 255, 0.7)',
  LoadingBgColorPart: 'rgba(255, 255, 255, 1)',
  CNYCurrency: 'CNY',
  BookingPaxType: 'AD',
  CompanyFootName: 'Copyright © 2019-2023, cozy-time.com.All Rights Reserved 深圳市科坦科技有限公司 版权所有',
  CompanyFootCode: '粤ICP备20000912号',
  SearchRoomCount: 4,
  SearchAdultCount: 4,
  B2BAPIResultCode_Success: 0,
  B2BAPIResultCode_NoRoom: 103,
  B2BAPIResultCode_InsufficientAmount: 106,
  BaiduMapAK: 'j3ZVgCdYIHimsGkSuQlbDz1RrUG1651u',
  PhoneRegions: [
    { id: 1, name: '中国大陆', value: '+86' },
    { id: 2, name: '中国澳门', value: '+853' },
    { id: 3, name: '中国台湾', value: '+886' },
    { id: 4, name: '中国香港', value: '+852' }
  ]
}



// WEBPACK FOOTER //
// ./src/assets/js/FinalData.js